// tab页太多，使用index.vue作为主页面
import Index from './index.vue'
export default Index
